module.exports = __webpack_public_path__ + "img/sciencepage2.3c2f14b8.png";